<template>
  <div class="bottom">
      <!-- 页面底部内容 -->
      <div class="bottom-text">
          <p>友情链接</p>
          <div class="lianjie">
              <a target="_blank" v-for="item in navs" :key="item.id" :href="item.nav">{{item.navtit}}</a>
          </div>
      </div>
      <div class="xian"></div>
      <!-- 最后内容 -->
      <div class="danwei">
          <span>组织单位：</span>
          <a target="_blank" v-for="item in danwei" :key="item.id" class="danweis" :href="item.danweinav">{{item.danweim}}</a> <br>
          <a target="_blank" v-for="item2 in yinsi" :key="item2.id" :href="item2.yinsinav">{{item2.yinsitxt}}</a>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            navs:[
                {nav:"http://www.moe.gov.cn/",navtit:"中华人民共和国教育部"},
                {nav:"http://www.hep.com.cn/",navtit:"高等教育出版社"},
                {nav:"http://www.tech.net.cn/",navtit:"中国高职高专教育网"},
                {nav:"http://www.hepmall.com.cn/",navtit:"高教社网上书城"},
                {nav:"http://www.enetedu.com/",navtit:"全国高校教师网络培训中心"},
                {nav:"https://weidian.com/?userid=899960007&wfr=c&ifr=shopdetail",navtit:"高教社官方微店"},
                {nav:"http://dxs.moe.gov.cn/zx/",navtit:"中国大学生在线"},
                {nav:"https://hebei.icve.com.cn/portal/home.html",navtit:"河北省职教云平台"},
                {nav:"https://jiangsu.icve.com.cn/portal/home.html",navtit:"江苏省职教云平台"},
                {nav:"https://zhejiang.icve.com.cn/portal/home.html",navtit:"浙江省教学能力比赛平台"},
                {nav:"https://guizhou.icve.com.cn/portal/home.html",navtit:"四川省教学能力比赛平台"},
                {nav:"https://sc.icve.com.cn/portal/home.html",navtit:"内蒙古教学能力比赛平台"},
                {nav:"https://hlj.icve.com.cn/im/",navtit:"黑龙江省教学能力比赛平台"},

                ],

                danwei:[
                   {danweinav:"https://www.baidu.com",danweim:"全国铁道职业教育教学指导委员会"},
                   {danweinav:"https://www.baidu.com",danweim:"铁道供电专业教学指导委员会"},
                   {danweinav:"https://www.baidu.com",danweim:"郑州铁路职业技术学院"},
                   {danweinav:"https://www.baidu.com",danweim:"广州铁路职业技术学院"},
                   {danweinav:"https://www.baidu.com",danweim:"技术支持：郑州简意科技有限公司"},

                ],
                yinsi:[
                    {yinsinav:"https://www.baidu.com",yinsitxt:"| 隐私政策 "},
                    {yinsinav:"https://www.baidu.com",yinsitxt:"| 侵权投诉 "},
                    {yinsinav:"https://www.baidu.com",yinsitxt:"| 问题反馈 "},
                    {yinsinav:"https://www.baidu.com",yinsitxt:" | 帮助"},
                ]
        }
    }
}
</script>

<style>
.bottom{
     width: 100%;
     height: 2.7rem;
     background: #444546;
     overflow: hidden;
}
/* 底部内容和链接 */
 .bottom-text{
     width: 13.39rem;
    /* height: 0.65rem;
     */
    /* border: 1px solid red;
     */
     margin: 0.34rem auto;
}
 .bottom-text>p{
     font-size: 0.18rem;
     font-family: PingFang SC;
     font-weight: 500;
     color: #949595;
     line-height: 0.26rem;
     margin-left: 0.25rem;
}
 .lianjie{
     width: 12.4rem;
    /* border: 1px solid red;
     */
     margin-left: 0.22rem;
}
 .lianjie>a{
     text-decoration: none;
     font-size: 0.14rem;
     font-family: PingFang SC;
     font-weight: 400;
     color: #949595;
     line-height: 0.26rem;
     padding-right: 0.2rem;
}
/* 线 */
 .xian{
     width: 15rem;
     height: 0.01rem;
     background: #4C4D4E;
     margin: 0 auto;
}
/* 组织单位 */
 .danwei{
     width: 10.16rem;
     height: 0.41rem;
     font-size: 0.14rem;
     font-family: PingFang SC;
     font-weight: 400;
     color: #949595;
     line-height: 0.26rem;
     margin: 0.5rem auto;
     text-align: center;
}
 .danweis{
     margin-left: 0.08rem;
}
 .danwei>a{
     text-decoration: none;
     color: #949595;
     line-height: 0.26rem;
}

</style>



// WEBPACK FOOTER //
// src/components/BotTom.vue